import { RootState } from '@store/rootReducer'

export const selectAllSlides = (state: RootState) => state.slides.entities
export const selectAllSlideIds = (state: RootState) => state.slides.allIds
export const selectCurrentSlideId = (state: RootState) => state.slides.current
export const selectSlidesObjectState = (state: RootState) => state.slides.slidesObjectState
export const selectFirstSlideId = (state: RootState) =>
  state?.projects?.currentProject?.slideOrder[0] || null
